module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-BoldItalic.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-BoldItalic.eot
 ** module id = 343
 ** module chunks = 0
 **/